export * from './news.component'